import { bool, string } from 'prop-types';
import React from 'react';
import { components } from 'react-select';

const CheckboxOption = props => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{' '}
        <label htmlFor="selectLabel">{props.label}</label>
      </components.Option>
    </div>
  );
};

CheckboxOption.propTypes = {
  isSelected: bool.isRequired,
  label: string.isRequired,
};

export default CheckboxOption;
